import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/providers/AuthProvider'

/**
 * Route guard: renders the protected layout only when authenticated, otherwise
 * redirects to /login while remembering where the user was headed (unless a
 * session just ended; see `sessionEnded`).
 */
export function RequireAuth() {
  const { isAuthenticated, sessionEnded } = useAuth()
  const location = useLocation()

  if (!isAuthenticated) {
    // `from` is only for a first arrival (a deep link opened while signed
    // out). After a sign-out, the page on screen belongs to the session that
    // just ended; carrying it over would send the next person who signs in
    // to it, whoever they are.
    return <Navigate to='/login' replace state={sessionEnded ? undefined : { from: location }} />
  }
  return <Outlet />
}
